import { call, put, takeLatest } from 'redux-saga/effects';

import { fetchInvoiceTemplates } from 'api/invoices';
import { pushSiteError } from 'containers/App/actions';
import * as types from './types';

const getErrorMessage = 'We could get your invoice templates. Please refresh and try again.';

function* getInvoiceTemplates(action) {
  const { payload } = action || {};
  const { orgId } = payload || {};
  if (!orgId) {
    yield put(pushSiteError({ getErrorMessage }));
  }

  try {
    const response = yield call(fetchInvoiceTemplates, payload);
    if (response.ok) {
      yield put({ type: types.ADD_INVOICE_TEMPLATES, data: response.data });
    } else {
      yield put(pushSiteError({ getErrorMessage }));
    }
  } catch (err) {
    yield put(pushSiteError({ getErrorMessage }));
  }
};

export default function* watchList() {
  yield takeLatest(types.GET_INVOICE_TEMPLATES, getInvoiceTemplates);
};
